import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro233">
      <div className="bp2-intro233mobile anima-word-break ">
        <div className="bp2-mainbackground"></div>
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-couple">
              <img
                alt="Image/"
                src={background || backgroundImg}
                className="bp2-image bp2-intro233-anima-animate-enter"
              />
            </div>
            <div className="bp2-names bp2-intro233-anima-animate-enter3">
              <div className="notranslate bp2-couplesimplifiednam anima-valign-text-middle bp2-intro233-anima-animate-enter1">
                {coupleSimplifiedName.groom}
              </div>
              <div className="notranslate bp2-couplesimplifiednam1 anima-valign-text-middle bp2-intro233-anima-animate-enter2">
                {coupleSimplifiedName.bride}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp1-intro233desktop anima-word-break ">
        <div className="bp1-mainbackground"></div>
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-couple">
              <img
                alt="Image/"
                src={background || backgroundImg}
                className="bp1-image bp1-intro233-anima-animate-enter"
              />
            </div>
            <div className="bp1-names bp1-intro233-anima-animate-enter3">
              <div className="notranslate bp1-couplesimplifiednam anima-valign-text-middle bp1-intro233-anima-animate-enter1">
                {coupleSimplifiedName.groom}
              </div>
              <div className="notranslate bp1-couplesimplifiednam1 anima-valign-text-middle bp1-intro233-anima-animate-enter2">
                {coupleSimplifiedName.bride}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
